import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}><path d="M11.776 8.832a1.15 1.15 0 010-1.632c.224-.215.528-.347.864-.347s.64.132.864.348l9.344 8.864-9.344 8.736a1.276 1.276 0 01-1.729 0l.001.001a1.15 1.15 0 010-1.632l7.648-7.104z" /></svg>;